import { getApiBasepath } from 'api'

export const notifyMeService = async (artworkId: number) => {
  const res = await fetch(`${getApiBasepath()}/api/upcoming-releases`, {
    method: 'POST',
    body: JSON.stringify({ artworkId }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  return await res.json()
}

export const upcomingReleaseUserService = async (artworkId: number) => {
  const res = await fetch(`${getApiBasepath()}/api/upcoming-releases/user`, {
    method: 'POST',
    body: JSON.stringify({ artworkId }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  })
  return await res.json()
}
